import React, { useEffect, useRef, useState } from "react";
import SideMenuHOD from "../components/SideMenuHOD";
import Header from "../components/Header";

import RevenueBarChart from "../components/RevenueBarChart";
import axios from "axios";
import Datefilter from "../components/Datefilter";
import rightborder from "../assets/images/rightborder.png";
import { useNavigate } from "react-router-dom";
import toast, { Toaster } from "react-hot-toast";
import "../styles/App.css";

const DashboardAIG = () => {
  const navigate = useNavigate();
  const today = new Date();

  const formattedToday = `${today.getDate()}/${
    today.getMonth() + 1
  }/${today.getFullYear()}`;
  const [selectedOption, setSelectedOption] = useState("district");
  const [fromDate, setfromDate] = useState(formattedToday);
  const [toDate, settoDate] = useState(formattedToday);
  const hasToastShown = useRef(false);

  // Handle change event
  const handleChange = (event) => {
    const selectedRange = event.target.value; // Handle change event
    console.log("selectedRange:", selectedRange);

    try {
      let fromDateValue = "";
      let toDateValue = "";

      const today = new Date();
      const formattedToday = `${today.getDate()}/${
        today.getMonth() + 1
      }/${today.getFullYear()}`;

      if (selectedRange === "1D") {
        fromDateValue = formattedToday;
        toDateValue = formattedToday;
        console.log("fdate_D:", fromDateValue);
        console.log("tdate_D:", toDateValue);
      } else if (selectedRange === "1M") {
        const prevMonth = new Date();
        prevMonth.setMonth(prevMonth.getMonth() - 1);
        fromDateValue = `${prevMonth.getDate()}/${
          prevMonth.getMonth() + 1
        }/${prevMonth.getFullYear()}`;
        toDateValue = formattedToday;
        console.log("fdate_M:", fromDateValue);
        console.log("tdate_M:", toDateValue);
      } else if (selectedRange === "1Y") {
        const prevYear = new Date();
        prevYear.setFullYear(prevYear.getFullYear() - 1);
        fromDateValue = `${prevYear.getDate()}/${
          prevYear.getMonth() + 1
        }/${prevYear.getFullYear()}`;
        toDateValue = formattedToday;
        console.log("fdate_Y:", fromDateValue);
        console.log("tdate_Y:", toDateValue);
      }

      // Update state and call handleFilter AFTER state update
      setfromDate(fromDateValue);
      settoDate(toDateValue);

      // Use a timeout to ensure handleFilter gets updated state
      setTimeout(() => {
        handleFilter({ fromDate: fromDateValue, toDate: toDateValue });
        console.log("Final From Date:", fromDateValue);
        console.log("Final To Date:", toDateValue);
      }, 0);
    } catch (error) {
      console.error("Error in handleChange:", error);
    }
  };

  const handleFilter = (dates) => {
    console.log("Filtered Dates:", dates);
    console.log("F Dates:", dates.fromDate);
    console.log("t Dates:", dates.toDate);
    setfromDate(dates.fromDate);
    settoDate(dates.toDate);
    // You can fetch API data based on the selected date range here.
  };
  console.log("mode :", selectedOption);
  // useEffect(() => {
  //   toast((t) => (
  //     <div className="animate-slideIn fixed right-0 z-50 w-96 bg-white rounded-l-lg shadow-lg overflow-hidden">
  //       {/* Header */}
  //       <div className="flex justify-between items-center px-4 py-3 border-b">
  //         <h2 className="text-sm font-semibold flex items-center gap-2">
  //           🔄 New Power Regularization Request
  //         </h2>
  //         <button
  //           className="text-gray-500 hover:text-gray-800 text-lg font-bold"
  //           onClick={() => toast.dismiss(t.id)}
  //         >
  //           &times;
  //         </button>
  //       </div>

  //       {/* Content */}
  //       <div className="p-4">
  //         <div className="flex items-center bg-gray-100 rounded-lg p-3 shadow text-xs">
  //           <span className="text-[#4F9CF9] text-2xl">👤</span>
  //           <div className="ml-3 flex-1">
  //             <p className="font-semibold">
  //               Rahul Rawat,{" "}
  //               <span className="text-gray-500">Udham Singh Nagar</span>
  //             </p>
  //             <p className="text-sm">
  //               <strong>SRO:</strong> Kashipur
  //             </p>
  //             <p className="text-xs text-gray-500">4 hours ago</p>
  //           </div>
  //           <button
  //             onClick={() => navigate("/PowerRegularizationAIGAction")}
  //             className="text-[#4F9CF9] text-sm hover:underline font-semibold"
  //           >
  //             View all
  //           </button>
  //         </div>
  //       </div>

  //       <img
  //         src={rightborder}
  //         alt="Sidebar"
  //         className="absolute right-0 top-0 h-full w-4"
  //       />
  //     </div>
  //   ));
  // }, []);

  useEffect(() => {
    if (hasToastShown.current) return; // Prevent duplicate execution
    hasToastShown.current = true; // Set flag to prevent future runs

    toast((t) => (
      <div className="animate-slideIn fixed right-0 z-50 w-96 bg-white rounded-l-lg shadow-lg overflow-hidden">
        {/* Header */}
        <div className="flex justify-between items-center px-4 py-3 border-b">
          <h2 className="text-sm font-semibold flex items-center gap-2">
            🔄 New Power Regularization Request
          </h2>
          <button
            className="text-gray-500 hover:text-gray-800 text-lg font-bold"
            onClick={() => toast.dismiss(t.id)}
          >
            &times;
          </button>
        </div>

        {/* Content */}
        <div className="p-4">
          <div className="flex items-center bg-gray-100 rounded-lg p-3 shadow text-xs">
            <span className="text-[#4F9CF9] text-2xl">👤</span>
            <div className="ml-3 flex-1">
              <p className="font-semibold">
                Rahul Rawat,{" "}
                <span className="text-gray-500">Udham Singh Nagar</span>
              </p>
              <p className="text-sm">
                <strong>SRO:</strong> Kashipur
              </p>
              <p className="text-xs text-gray-500">4 hours ago</p>
            </div>
            <button
              onClick={(e) => {
                e.preventDefault();
                navigate("/PowerRegularizationAIGAction");
              }}
              className="text-[#4F9CF9] text-sm hover:underline font-semibold"
            >
              View all
            </button>
          </div>
        </div>

        <img
          src={rightborder}
          alt="Sidebar"
          className="absolute right-0 top-0 h-full w-4"
        />
      </div>
    ));
  }, []);
  return (
    <div className="flex flex-row h-screen">
      <SideMenuHOD className="w-full md:w-64" />
      <div className="flex-1 flex flex-col overflow-hidden">
        <div className="shadow-sm">
          <Header />
        </div>

        <div className="flex flex-1 flex-col md:flex-row overflow-auto">
          {/* Left Side */}
          <div className="flex-1 p-4">
            <div className="p-1 bg-gray-100">
              <div className="w-full place-items-start justify-center">
                <h1 className="text-2xl md:text-4xl">Dashboard</h1>
                <div className="py-4 flex flex-col md:flex-row justify-between items-center w-full space-y-4 md:space-y-0">
                  {/* Radio Button Group */}
                  <div className="flex flex-col md:flex-row space-y-4 md:space-y-0 md:space-x-4">
                    <div className="flex p-1 bg-white rounded shadow-md">
                      {/* District Radio Button */}
                      <label className="cursor-pointer">
                        <input
                          type="radio"
                          name="options"
                          id="option1"
                          className="hidden peer"
                          defaultChecked
                          onChange={() => setSelectedOption("district")}
                        />
                        <div className="py-2 px-4 md:px-8 font-bold text-primary-black rounded-s-md peer-checked:bg-[#4F9CF9] peer-checked:text-primary-50 hover:text-primary-50 hover:bg-[#4F9CF9]">
                          District
                        </div>
                      </label>

                      {/* Srowise Radio Button */}
                      <label className="cursor-pointer">
                        <input
                          type="radio"
                          name="options"
                          id="option2"
                          className="hidden peer"
                          onChange={() => setSelectedOption("srowise")}
                        />
                        <div className="py-2 px-4 md:px-8 font-bold text-primary-black rounded-e-md peer-checked:bg-[#4F9CF9] peer-checked:text-primary-50 hover:text-primary-50 hover:bg-[#4F9CF9]">
                          Srowise
                        </div>
                      </label>
                    </div>

                    {selectedOption === "srowise" && (
                      <div className="ms-0 md:ms-4">
                        <select className="px-4 md:px-12 py-2 md:py-3 text-center border border-gray-300 rounded-md shadow-md">
                          <option value="Select" selected>
                            All District
                          </option>
                          <option value="sro1">SRO 1</option>
                          <option value="sro2">SRO 2</option>
                          <option value="sro3">SRO 3</option>
                        </select>
                      </div>
                    )}
                  </div>
                  <div className="flex flex-col md:flex-row space-y-4 md:space-y-0 md:space-x-4">
                    <>
                      <Toaster position="top-right" reverseOrder={false} />
                    </>
                    <div className="flex space-x-2">
                      <Datefilter onFilter={handleFilter} />
                      <button className="bg-primary-black py-2 px-4 md:px-6 font-bold hover:bg-gray-100 text-white border border-gray-400 rounded shadow-md">
                        Export
                      </button>
                    </div>
                  </div>
                </div>
                <div className="border border-secondary-200 rounded-lg shadow-lg w-full p-3">
                  <div className="grid grid-cols-1 md:grid-cols-3 items-center gap-4 p-4 bg-white">
                    {/* Left Side - Total State Revenue */}
                    <div className="flex items-center gap-2 justify-center md:justify-start">
                      <div className="border-secondary-200 rounded-s-lg shadow-md w-12 h-12 flex items-center justify-center border rounded-lg">
                        GIF
                      </div>
                      <div>
                        <p className="text-gray-500 text-sm">
                          Total State Revenue
                        </p>
                        <p className="text-black font-bold text-lg">
                          ₹ 50,75,000,00.00
                        </p>
                      </div>
                    </div>

                    {/* Middle - Total Document Registered */}
                    <div className="flex items-center gap-2 justify-center md:justify-start">
                      <div className="border-secondary-200 shadow-md w-12 h-12 flex items-center justify-center border rounded-lg">
                        GIF
                      </div>
                      <div>
                        <p className="text-gray-500 text-sm">
                          Total Document Registered
                        </p>
                        <p className="text-black font-bold text-lg">80,00000</p>
                      </div>
                    </div>

                    {/* Right Side - Time Filter Buttons */}
                    <div className="flex justify-center md:justify-end">
                      <div
                        className="inline-flex rounded-md shadow-md"
                        role="group"
                      >
                        <label className="flex items-center">
                          <input
                            type="radio"
                            name="timeFilter"
                            value="1Y"
                            className="hidden peer"
                            onChange={handleChange}
                          />
                          <span className="w-12 h-12 flex justify-center items-center peer-checked:bg-[#4F9CF9] peer-checked:text-primary-50 text-sm font-medium text-gray-900 bg-transparent border border-secondary-200 rounded-s-lg hover:bg-[#4F9CF9] hover:text-white focus:ring-2 focus:ring-primary-300 focus:bg-primary-300 focus:text-white dark:border-white dark:text-white dark:hover:text-white dark:hover:bg-gray-700 dark:focus:bg-gray-700 cursor-pointer">
                            1Y
                          </span>
                        </label>

                        <label className="flex items-center">
                          <input
                            type="radio"
                            name="timeFilter"
                            value="1M"
                            className="hidden peer"
                            onChange={handleChange}
                          />
                          <span className="w-12 h-12 flex justify-center items-center peer-checked:bg-[#4F9CF9] peer-checked:text-primary-50 text-sm font-medium text-gray-900 bg-transparent border-t border-b border-secondary-200 hover:bg-[#4F9CF9] hover:text-white focus:ring-2 focus:ring-primary-300 focus:bg-primary-300 focus:text-white dark:border-white dark:text-white dark:hover:text-white dark:hover:bg-gray-700 dark:focus:bg-gray-700 cursor-pointer">
                            1M
                          </span>
                        </label>

                        <label className="flex items-center">
                          <input
                            type="radio"
                            name="timeFilter"
                            value="1D"
                            className="hidden peer"
                            onChange={handleChange}
                            defaultChecked
                          />
                          <span className="w-12 h-12 flex justify-center items-center peer-checked:bg-[#4F9CF9] peer-checked:text-primary-50 text-sm font-medium text-gray-900 bg-transparent border border-secondary-200 rounded-e-lg hover:bg-[#4F9CF9] hover:text-white focus:ring-2 focus:ring-primary-300 focus:bg-primary-300 focus:text-white dark:border-white dark:text-white dark:hover:text-white dark:hover:bg-gray-700 dark:focus:bg-gray-700 cursor-pointer">
                            1D
                          </span>
                        </label>
                      </div>
                    </div>
                  </div>

                  <hr className="text-secondary-200 mt-2"></hr>
                  <div className="w-full overflow-x-auto sm:overflow-x-hidden">
                    <div className="min-w-[1500px] w-full">
                      <RevenueBarChart
                        mode={selectedOption}
                        Sro="All District"
                        fromDate={fromDate}
                        todate={toDate}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardAIG;
